import * as t from 'io-ts'

import fetchApi from "ui-io/fetch-api";
import { TaskAssignmentPayloadT } from 'ui-io/task-io'

const TaskAssignResultIO = t.type({
  task_id: t.string,
  type: t.string,
  configuration: t.partial({
    name: t.string,
  }),
})

export type TaskAssignMutationResultT = t.TypeOf<typeof TaskAssignResultIO>[]


export const taskAssignMutation = ({
  payload,
}: {
  payload: TaskAssignmentPayloadT
}) =>
  fetchApi({
    service: 'admin-service',
    method: 'POST',
    pathname: `/tasks/_assign`,
    body: payload,
    codec: t.array(TaskAssignResultIO),
  })